import { usePopup } from '@contexts/popupContext';
import { Flap } from '@models/Flap';
import { LockRounded } from '@mui/icons-material';
import styles from '@styles/components/General/TabDetailScreen.module.css';
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import ResultPopup from './ResultPopup';
import {LiteVersionPopup} from './ProhibitedPopups';

interface TabDetailScreenProps {
    title: string;
    flaps: Flap[];
    imgComponent?: JSX.Element;
    subtitle?: string;
    clickedScreen: string;
    setClickedScreen: (screen: string) => void;
}

const TabDetailScreen: React.FC<TabDetailScreenProps> = ({ title, flaps, clickedScreen, setClickedScreen, imgComponent, subtitle }) => {
    
    const navigate = useNavigate();
    const { showPopup } = usePopup();
    const safeFlaps = flaps.filter((flap): flap is Flap => Boolean(flap));

    const handleNavigation = (path, state?) => {
        navigate(path, { state });
    };

    return (
        <div className={styles['content-block']}>
            <div className={styles['header-container']}>
                <div className={styles['title-container']}>
                    <h2 className={styles['title']} style={{gap: '10px'}}>
                        <div className={styles['svg-container']} style={{width: '45px', height: '45px', cursor: 'pointer'}} onClick={() => {handleNavigation(-1)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 36 36" fill="none">
                                <path d="M21.375 11.625L14.625 18L21.375 24.375" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        {imgComponent &&
                            <div className={styles['circle-mask']} style={{marginRight: '10px'}}>
                                {imgComponent}
                            </div>
                        }
                        {title}
                    </h2>
                    {subtitle && <span className={styles['subtitle']}>{subtitle}</span>}
                </div>
            </div>
            <div className={styles['content-container']}>
                <div className={styles['flaps-container']}>
                    {safeFlaps.map((flap) => {
                        return (
                            <div
                                key={flap.id}
                                className={`${styles['flap']} ${clickedScreen === flap.id ? styles['clicked'] : ''} ${flap.isLocked ? styles['locked'] : ''}`}
                                onClick={() => {
                                    if (flap.isLocked) {
                                        showPopup(() => <LiteVersionPopup/>);
                                        return;
                                    }
                                    setClickedScreen(flap.id)
                                }}
                            >
                                {flap.label}
                                {flap.isLocked && <LockRounded style={{position: 'absolute', right: '15px', aspectRatio: 1, width: '20px'}}/>}
                            </div>
                        )
                    })}
                </div>
                <div className={styles['inner-container']} style={{ zIndex: 1 }}>
                    {safeFlaps.find(flap => flap.id === clickedScreen)?.content}
                </div>
            </div>
        </div>
    );
};

interface TabDetailScreenWrapperProps extends TabDetailScreenProps { 
    flag: any;
}

const TabDetailScreenWrapper: React.FC<TabDetailScreenWrapperProps> = ({ title, flaps, flag, clickedScreen, setClickedScreen, imgComponent, subtitle }) => {
    if (!flag) {
        return <Navigate to="/" />;
    }

    return <TabDetailScreen title={title} subtitle={subtitle} flaps={flaps} clickedScreen={clickedScreen} setClickedScreen={setClickedScreen} imgComponent={imgComponent}/>;
};

export { TabDetailScreenWrapper };
